import { render, staticRenderFns } from "./PartADescription.vue?vue&type=template&id=697b46a9&lang=pug"
import script from "./PartADescription.vue?vue&type=script&lang=js"
export * from "./PartADescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports